import { render } from "./icon-person.vue?vue&type=template&id=ceb715fe"
import script from "./icon-person.vue?vue&type=script&lang=js"
export * from "./icon-person.vue?vue&type=script&lang=js"

import exportComponent from "/opt/TeamCity/buildAgent/work/f19c936fb20a8ac2/vue-embed/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__